import React from "react"

import { type IconProps } from "./utils"

export default function GraduateCapIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66459 2.32918C8.87574 2.22361 9.12426 2.22361 9.33541 2.32918L16.8354 6.07918C17.0895 6.20622 17.25 6.46592 17.25 6.75V11.25C17.25 11.6642 16.9142 12 16.5 12C16.0858 12 15.75 11.6642 15.75 11.25V7.96353L14.25 8.71353V12.0104C14.25 12.8627 13.7685 13.6418 13.0062 14.0229L10.0062 15.5229C9.37279 15.8396 8.62721 15.8396 7.99377 15.5229L4.99377 14.0229C4.2315 13.6418 3.75 12.8627 3.75 12.0104V8.71353L1.16459 7.42082C0.910502 7.29378 0.75 7.03408 0.75 6.75C0.75 6.46592 0.910502 6.20622 1.16459 6.07918L8.66459 2.32918ZM4.8489 7.58593C4.83967 7.58107 4.83033 7.57639 4.82088 7.57191L3.17705 6.75L9 3.83853L14.8229 6.75L13.1791 7.57191C13.1697 7.5764 13.1603 7.58107 13.1511 7.58593L9 9.66147L4.8489 7.58593ZM5.25 9.46353V12.0104C5.25 12.2945 5.4105 12.5542 5.66459 12.6813L8.66459 14.1813C8.87574 14.2868 9.12426 14.2868 9.33541 14.1813L12.3354 12.6813C12.5895 12.5542 12.75 12.2945 12.75 12.0104V9.46353L9.33541 11.1708C9.12426 11.2764 8.87574 11.2764 8.66459 11.1708L5.25 9.46353Z"
        fill="currentColor"
      />
    </svg>
  )
}
